import { User } from "luxedo-data"
import { UserStore } from "../stores/UserStore.svelte"

class UserCtx {
	user: User = $state()

	constructor() {
		UserStore.subscribe(this.updateUser)
	}

	private updateUser = (user: User) => {
		this.user = user
	}
}

export const UserContext = new UserCtx()
